import {Ambiente} from './ambiente';
import {InfoPedido} from './info-pedido';
import {InformacaoDoCliente} from './informacoes-do-cliente';

export class InformacaoExtrator {
  public versaoDoProduto: string;
  public conectado: boolean;
  public informacoesDoCliente: InformacaoDoCliente;
  public versaoDoBDNuvem: string;
  public ambiente: Ambiente;
  public informacoesDoClienteAPartirDoServidor: InfoPedido;
}
